import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/useAuth";
import { useNavigate } from "react-router-dom";
import { getInitials } from "../../utils/strings";
import { Button } from "../ui/Button";
import { OrgSelector } from "./OrgSelector";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { NotificationBell } from "./NotificationBell";
import { EnvBadge } from "./EnvBadge";
import { s } from "./TopBar.styles";

interface TopBarProps {
  sidebarCollapsed: boolean;
  onMobileMenuOpen?: () => void;
}

export function TopBar({ sidebarCollapsed, onMobileMenuOpen }: TopBarProps) {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header
      className={`fixed top-0 right-0 z-20 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 md:px-6 transition-all duration-200
        left-0 ${sidebarCollapsed ? "nav:left-16" : "nav:left-60"}`}
    >
      <div className="flex items-center gap-3">
        {/* Mobile hamburger */}
        <button
          onClick={onMobileMenuOpen}
          title={t("common:actions.menu")}
          aria-label={t("common:actions.menu")}
          className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 nav:hidden"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <OrgSelector />
      </div>
      <div className="flex items-center gap-4">
        <EnvBadge />
        <NotificationBell />
        <LanguageSwitcher />
        {user && (
          <div
            onClick={() => navigate("/profile")}
            className={`${s.avatarBase} ${user.avatar ? s.avatarImage : s.avatarInitials}`}
            title={user.name}
          >
            {user.avatar ? (
              <img src={user.avatar} alt={user.name} className={s.avatarImg} />
            ) : (
              getInitials(user.name)
            )}
          </div>
        )}
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          {t("common:actions.logout")}
        </Button>
      </div>
    </header>
  );
}
